import classNames from 'classnames';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_REVIEW_CUSTOMER_LABEL, TYPOGRAPHY_REVIEW_CUSTOMER_TEXT } from 'lib/typography';
import StarRating from './StarRating';

interface Props {
  date: Date;
  rating: number;
  text: string;
  className?: string;
}

const CustomerReview: React.FC<Props> = ({ date, rating, text, className }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  return (
    <div className={classNames('flex flex-col gap-2', className)}>
      <p>{date.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}</p>
      <StarRating variant="sm" rating={rating} />
      <p className={TYPOGRAPHY_REVIEW_CUSTOMER_TEXT}>{text}</p>
      <p className={TYPOGRAPHY_REVIEW_CUSTOMER_LABEL}>
        {formatMessage({ id: 'feedaty.verifiedCustomer', defaultMessage: 'Cliente verificato' })}
      </p>
    </div>
  );
};

export default CustomerReview;
